
import { Vue, Component, Prop } from 'vue-property-decorator';
import QueryStringTableRow from '@/features/query-string/components/QueryStringTableRow.vue';
import { QueryStringValue } from '@/features/query-string/views/QueryString.vue';

@Component({
  components: {
    QueryStringTableRow,
  },
})
export default class QueryStringTable extends Vue {
  @Prop({ required: true }) items!: QueryStringValue[];

  @Prop({ required: true }) endpointName!: string;
}
